import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import TextInput from "@/components/inputs/text.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import SaleOrderEditor from "@/components/editors/sale_order.vue"
  import {Order as OrderClient} from "@/endpoints/rutsolve/gql/resolvers/order"
  import {onBeforeMount, ref} from "vue"
  import {
    Order,
    ContactDetails,
    OrderLine,
    File
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Button from "@/components/button.vue"
  import router from "@/router"
  import ErrorModal from "@/components/modals/error.vue"
  import {OrderLine as OrderLineClient} from "@/endpoints/rutsolve/gql/resolvers/order_line"
  import {ContactDetails as ContactDetailsClient} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {File as FileClient} from "@/endpoints/rutsolve/gql/resolvers/file"
  import DeliverablePicker from "@/components/selectors/deliverable.vue"
  import OrderLineEditor from "@/components/editors/order_line.vue"
  import FileEditor from "@/components/editors/file.vue"
  import ContentModal from "@/components/modals/content.vue"
  import OrderLineList from "@/components/lists/order_line.vue"
  import FileList from "@/components/lists/file.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import {useRoute} from "vue-router"
  import ConfirmationModal from "@/components/modals/confirmation.vue"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

  const order = ref<Order>(null)
  const error = ref<Error>(null)
  const orderClient = new OrderClient()
  const orderLineClient = new OrderLineClient()
  const fileClient = new FileClient()
  const contactDetailsClient = new ContactDetailsClient()
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const selectedFile = ref<File>(null)
  const selectedFileIndex = ref<number>(null)
  const selectedOrderLine = ref<OrderLine>(null)
  const selectedOrderLineIndex = ref<number>(null)
  const pickDeliverable = ref<boolean>(null)
  const confirmRemove = ref<boolean>(false)
  
  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const orderID = useRoute().params.orderID.toString()
      order.value = await orderClient.order(orderID)
      if (!order.value.contactDetails || !order.value.contactDetails.records) {
        order.value.contactDetails = {
          records: []
        }
      }
      if (!order.value.files || !order.value.files.records) {
        order.value.files = {
          records: []
        }
      }
      if (!order.value.orderLines || !order.value.orderLines.records) {
        order.value.orderLines = {
          records: []
        }
      }
    } catch(e) {
      error.value = e
    }
  }
  
  async function save() {
    try {
      await orderClient.update(order.value)
      for (const contactDetails of order.value.contactDetails.records) {
        contactDetails.relationID = order.value.id
        contactDetails.relationType = "ORDER"
        if (contactDetails.deletedAt) {
          await contactDetailsClient.remove(contactDetails.id)
        } else if(contactDetails.id) {
          await contactDetailsClient.update(contactDetails)
        } else {
          await contactDetailsClient.create(contactDetails)
        }
      }
      for (const file of order.value.files.records) {
        file.relationID = order.value.id
        file.relationType = "ORDER"
        if (file.deletedAt) {
          await fileClient.remove(file.id)
        } else if(file.id) {
          await fileClient.update(file)
        } else {
          await fileClient.create(file)
        }
      }
      for (const orderLine of order.value.orderLines.records) {
        orderLine.orderID = order.value.id
        if (orderLine.deletedAt) {
          await orderLineClient.remove(orderLine.id)
        } else if(orderLine.id) {
          await orderLineClient.update(orderLine)
        } else {
          await orderLineClient.create(orderLine)
        }
      }
      ordersRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await orderClient.remove(order.value.id)
      ordersRedirect()
    } catch(e) {
      error.value = e
    }
  }
  
  function ordersRedirect() {
    router.push({
      name: "sale_order_overview",
    })
  }
  
  function selectDeliverable() {
    selectedOrderLine.value.amount = 1
    selectedOrderLine.value.deliverableID = selectedOrderLine.value.deliverable.id
    selectedOrderLine.value.description = selectedOrderLine.value.deliverable.name
    selectedOrderLine.value.unit = selectedOrderLine.value.deliverable.unit
    selectedOrderLine.value.unitPrice = selectedOrderLine.value.deliverable.unitPrice
    selectedOrderLine.value.vatRate = selectedOrderLine.value.deliverable.vatRate
    pickDeliverable.value = false
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          (order.value)
            ? (_openBlock(), _createBlock(Breadcrumb, {
                key: 0,
                links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Sale Orders',
          routeName: 'sale_order_overview'
        }],
                title: `${order.value.type} ${order.value.number}`
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _cache[27] || (_cache[27] = _createElementVNode("h1", null, " Edit Sale Order ", -1)),
          _createVNode(SaleOrderEditor, {
            value: order.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((order).value = $event))
          }, null, 8, ["value"]),
          _cache[28] || (_cache[28] = _createElementVNode("h2", null, " Customer ", -1)),
          (order.value && order.value.customer)
            ? (_openBlock(), _createBlock(TextInput, {
                key: 1,
                readOnly: "",
                value: order.value.customer.name
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _cache[29] || (_cache[29] = _createElementVNode("h2", null, " Order Lines ", -1)),
          (order.value && order.value.orderLines)
            ? (_openBlock(), _createBlock(OrderLineList, {
                key: 2,
                items: order.value.orderLines.records,
                "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((order.value.orderLines.records) = $event)),
                selectedIndex: selectedOrderLineIndex.value,
                "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedOrderLineIndex).value = $event)),
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (selectedOrderLine.value = order.value.orderLines.records[selectedOrderLineIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedOrderLine.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(Button, {
                    title: "Deliverable",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (pickDeliverable.value = true))
                  }),
                  (pickDeliverable.value)
                    ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(DeliverablePicker, {
                            value: selectedOrderLine.value.deliverable,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((selectedOrderLine.value.deliverable) = $event)),
                            onSelect: _cache[6] || (_cache[6] = ($event: any) => (selectDeliverable()))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(OrderLineEditor, {
                    value: selectedOrderLine.value,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((selectedOrderLine).value = $event))
                  }, null, 8, ["value"]),
                  _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (selectedOrderLine.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[30] || (_cache[30] = _createElementVNode("h2", null, " Contact Details ", -1)),
          (order.value && order.value.contactDetails)
            ? (_openBlock(), _createBlock(ContactDetailsList, {
                key: 4,
                items: order.value.contactDetails.records,
                "onUpdate:items": _cache[9] || (_cache[9] = ($event: any) => ((order.value.contactDetails.records) = $event)),
                selectedIndex: selectedContactDetailsIndex.value,
                "onUpdate:selectedIndex": _cache[10] || (_cache[10] = ($event: any) => ((selectedContactDetailsIndex).value = $event)),
                onSelect: _cache[11] || (_cache[11] = ($event: any) => (selectedContactDetails.value = order.value.contactDetails.records[selectedContactDetailsIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedContactDetails.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 5 }, {
                default: _withCtx(() => [
                  _createVNode(ContactDetailsEditor, {
                    value: selectedContactDetails.value,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((selectedContactDetails).value = $event))
                  }, null, 8, ["value"]),
                  _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (selectedContactDetails.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[31] || (_cache[31] = _createElementVNode("h2", null, " Files ", -1)),
          (order.value && order.value.files)
            ? (_openBlock(), _createBlock(FileList, {
                key: 6,
                items: order.value.files.records,
                "onUpdate:items": _cache[14] || (_cache[14] = ($event: any) => ((order.value.files.records) = $event)),
                selectedIndex: selectedFileIndex.value,
                "onUpdate:selectedIndex": _cache[15] || (_cache[15] = ($event: any) => ((selectedFileIndex).value = $event)),
                onSelect: _cache[16] || (_cache[16] = ($event: any) => (selectedFile.value = order.value.files.records[selectedFileIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedFile.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 7 }, {
                default: _withCtx(() => [
                  _createVNode(FileEditor, {
                    value: selectedFile.value,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((selectedFile).value = $event))
                  }, null, 8, ["value"]),
                  _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (selectedFile.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(Button, {
            title: "Remove",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (confirmRemove.value = true))
          }),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (ordersRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (save()))
          }),
          _createVNode(ConfirmationModal, {
            display: confirmRemove.value,
            "onUpdate:display": _cache[22] || (_cache[22] = ($event: any) => ((confirmRemove).value = $event)),
            callback: remove,
            message: "This action will remove selected order.",
            title: "Remove Order"
          }, null, 8, ["display"])
        ]),
        _: 1
      }),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[23] || (_cache[23] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})